import dynamic from "next/dynamic";
const App = dynamic(() => import("../../components/App"));
import Head from "next/head";
import { useRouter } from "next/router";
import { Breadcrumb, Typography, Row, Col, Table } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Link from "next/link";

const { Title } = Typography;

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { t } = useTranslation("common");

  const dataSourceShoes = [
    {
      key: "1",
      woman: "3.5",
      man: "2",
      eu: "34",
    },
    {
      key: "2",
      woman: "4",
      man: "2.5",
      eu: "34.5",
    },
    {
      key: "3",
      woman: "4.5",
      man: "3",
      eu: "35",
    },
    {
      key: "4",
      woman: "5",
      man: "3.5",
      eu: "35.5",
    },
    {
      key: "5",
      woman: "5.5",
      man: "4",
      eu: "36",
    },
    {
      key: "6",
      woman: "6",
      man: "4.5",
      eu: "36.5",
    },
    {
      key: "7",
      woman: "6.5",
      man: "5",
      eu: "37.5",
    },
    {
      key: "8",
      woman: "7",
      man: "5.5",
      eu: "38",
    },
    {
      key: "9",
      woman: "7.5",
      man: "6",
      eu: "38.5",
    },
    {
      key: "10",
      woman: "8",
      man: "6.5",
      eu: "39",
    },
    {
      key: "11",
      woman: "8.5",
      man: "7",
      eu: "40",
    },
    {
      key: "12",
      woman: "9",
      man: "7.5",
      eu: "40.5",
    },
    {
      key: "13",
      woman: "9.5",
      man: "8",
      eu: "41",
    },
    {
      key: "14",
      woman: "10",
      man: "8.5",
      eu: "42",
    },
    {
      key: "15",
      woman: "10.5",
      man: "9",
      eu: "42.5",
    },
    {
      key: "16",
      woman: "11",
      man: "9.5",
      eu: "43",
    },
    {
      key: "17",
      woman: "11.5",
      man: "10",
      eu: "44",
    },
    {
      key: "18",
      woman: "12",
      man: "10.5",
      eu: "44.5",
    },
    {
      key: "19",
      woman: "12.5",
      man: "11",
      eu: "45",
    },
    {
      key: "20",
      woman: "13",
      man: "11.5",
      eu: "45.5",
    },
    {
      key: "21",
      woman: "13.5",
      man: "12",
      eu: "46",
    },
    {
      key: "22",
      woman: "14",
      man: "12.5",
      eu: "47",
    },
    {
      key: "23",
      woman: "15",
      man: "13",
      eu: "47.5",
    },
    {
      key: "24",
      woman: "16",
      man: "13.5",
      eu: "48",
    },
  ];

  const columnsShoes = [
    {
      title: "US Women",
      dataIndex: "woman",
      key: "woman",
      align: "center",
      width: "33.33%",
    },
    {
      title: "US Men",
      dataIndex: "man",
      key: "man",
      align: "center",
      width: "33.33%",
    },
    {
      title: "EU",
      dataIndex: "eu",
      key: "eu",
      align: "center",
      width: "33.33%",
    },
  ];

  const dataSourceShirt = [
    {
      key: "1",
      eu: "26",
      uk: "2",
    },
    {
      key: "2",
      eu: "35",
      uk: "2.5",
    },
    {
      key: "3",
      eu: "35.5",
      uk: "3",
    },
    {
      key: "4",
      eu: "36",
      uk: "3.5",
    },
    {
      key: "5",
      eu: "36.5",
      uk: "4",
    },
    {
      key: "6",
      eu: "37",
      uk: "4.5",
    },
    {
      key: "7",
      eu: "37.5",
      uk: "5",
    },
    {
      key: "8",
      eu: "38",
      uk: "5.5",
    },
    {
      key: "9",
      eu: "38.5",
      uk: "6",
    },
    {
      key: "10",
      eu: "39",
      uk: "6.5",
    },
    {
      key: "11",
      eu: "39.5",
      uk: "7",
    },
    {
      key: "12",
      eu: "40",
      uk: "7.5",
    },
    {
      key: "13",
      eu: "40.5",
      uk: "8",
    },
    {
      key: "14",
      eu: "41",
      uk: "8.5",
    },
    {
      key: "15",
      eu: "41.5",
      uk: "9",
    },
    {
      key: "16",
      eu: "42",
      uk: "",
    },
  ];

  const columnsShirt = [
    {
      title: "Size EU",
      dataIndex: "eu",
      key: "eu",
      align: "center",
      width: "50%",
    },
    {
      title: "Size UK",
      dataIndex: "uk",
      key: "uk",
      align: "center",
      width: "50%",
    },
  ];

  const dataSourceTrousers = [
    {
      key: "1",
      eu: "XXS",
      uk: "2",
    },
    {
      key: "2",
      eu: "XS",
      uk: "2.5",
    },
    {
      key: "3",
      eu: "S",
      uk: "3",
    },
    {
      key: "4",
      eu: "M",
      uk: "3.5",
    },
    {
      key: "5",
      eu: "L",
      uk: "4",
    },
    {
      key: "6",
      eu: "XL",
      uk: "4.5",
    },
    {
      key: "7",
      eu: "2XL",
      uk: "5",
    },
    {
      key: "8",
      eu: "3XL",
      uk: "5.5",
    },
    {
      key: "9",
      eu: "4XL",
      uk: "6",
    },
    {
      key: "10",
      eu: "5XL",
      uk: "6.5",
    },
  ];

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Size Chart</title>
      </Head>
      <Row justify="center" style={{ marginBlock: 24 }}>
        <Col xs={22} sm={22} md={20} lg={18} xl={16}>
          <Breadcrumb
            items={[
              {
                key: "home",
                title: (
                  <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                key: "size-chart",
                title: `${t("size-chart")}`,
              },
            ]}
          />
        </Col>
        <Col xs={22} sm={22} md={20} lg={18} xl={16}>
          <p className="h4" style={{ marginBlock: 24 }}>
            {t("shoe")}
          </p>
          <Table
            dataSource={dataSourceShoes}
            columns={columnsShoes}
            pagination={false}
            size={"small"}
            bordered
          />
        </Col>
        <Col xs={22} sm={22} md={20} lg={18} xl={16}>
          <p className="h4" style={{ marginBlock: 24 }}>
            {t("shirt")}
          </p>
          <Table
            dataSource={dataSourceShirt}
            columns={columnsShirt}
            pagination={false}
            size={"small"}
            bordered
          />
        </Col>
        <Col xs={22} sm={22} md={20} lg={18} xl={16}>
          <p className="h4" style={{ marginBlock: 24 }}>
            {t("trouser")}
          </p>
          <Table
            dataSource={dataSourceTrousers}
            columns={columnsShirt}
            pagination={false}
            size={"small"}
            bordered
          />
        </Col>
      </Row>
    </App>
  );
};

export default Home;
